(() => {
  'use strict';
  const config = document.getElementById('lmb-wishlist-share-config');
  if (!config || window.__lmbWishlistShareStarted) return;
  window.__lmbWishlistShareStarted = true;
  const labels = Object.fromEntries(Array.from(config.querySelectorAll('[data-label]'), node => [node.dataset.label, node.textContent]));
  const text = key => labels[key] || key;
  const configuredRoot = config.dataset.root || '/';
  const root = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(configuredRoot) ? configuredRoot.replace(/\/?$/, '/') : '/';
  const max = 40;
  const handlePattern = /^[a-z0-9][a-z0-9-]{0,179}$/;
  const make = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  function icon(kind) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    const paths = {"share":"M12 16V3m-4 4 4-4 4 4M5 12v8h14v-8","copy":"M8 8h12v12H8zM16 8V4H4v12h4","mail":"M3 5h18v14H3zM3 6l9 7 9-7","whatsapp":"M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z","instagram":"M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077","facebook":"M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"};
    const path = document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d',paths[kind] || paths.share);
    if (['whatsapp','instagram','facebook'].includes(kind)) {
      path.style.fill = 'currentColor';
      path.style.stroke = 'none';
    }
    svg.append(path);
    return svg;
  }
  function decodeProductTitle(value) {
    const entities = {amp:'&',quot:'"',apos:"'",lt:'<',gt:'>',nbsp:'\u00a0'};
    return String(value).replace(/&(#(?:x[0-9a-f]{1,6}|[0-9]{1,7})|amp|quot|apos|lt|gt|nbsp);/gi, (original, entity) => {
      if (entity.charAt(0) !== '#') return entities[entity.toLowerCase()];
      const hex = entity.charAt(1).toLowerCase() === 'x';
      const point = parseInt(entity.slice(hex ? 2 : 1), hex ? 16 : 10);
      return point > 0 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff) ? String.fromCodePoint(point) : original;
    });
  }
  function wishlistHandles(drawer) {
    const result = [];
    drawer.querySelectorAll('.nm-wishlist-drawer-body a[href], .nm-wishlist-item-card a[href]').forEach(link => {
      try {
        const url = new URL(link.href, location.origin);
        const match = url.pathname.match(/\/products\/([a-z0-9-]+)\/?$/);
        if (url.origin === location.origin && match && handlePattern.test(match[1]) && !result.includes(match[1])) result.push(match[1]);
      } catch (_) {}
    });
    return result;
  }
  function dialog(title) {
    document.querySelectorAll('.lmb-wishlist-share-dialog').forEach(node => node.close());
    const node = make('dialog','lmb-wishlist-share-dialog');
    const heading = make('h2','',title);
    heading.id = 'lmb-wishlist-share-heading';
    node.setAttribute('aria-labelledby',heading.id);
    const close = make('button','lmb-wishlist-share-close','×');
    close.type = 'button';
    close.setAttribute('aria-label',text('close'));
    close.addEventListener('click',() => node.close());
    node.append(heading,close);
    const previous = document.activeElement;
    node.addEventListener('close',() => {node.remove(); if (previous && previous.isConnected) previous.focus();},{once:true});
    node.addEventListener('click',event => {if (event.target === node) {const rect=node.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)node.close();}});
    document.body.append(node);
    node.showModal();
    return node;
  }
  function publicUrl(handles) {
    const url = new URL(root,location.origin);
    url.hash = 'lmb-wishlist=' + encodeURIComponent('1:' + handles.join(','));
    return url.href;
  }
  function share(handles) {
    if (!handles.length) return;
    const panel = dialog(text('title'));
    if (handles.length > max) {panel.append(make('p','',text('too_many'))); return;}
    const url = publicUrl(handles);
    if (new URL(url).hash.length > 6000) {panel.append(make('p','',text('too_long'))); return;}
    panel.append(make('p','',text('note')));
    const channels = make('div','lmb-wishlist-share-channels');
    const status = make('p','lmb-wishlist-share-status');
    status.setAttribute('role','status');
    const copy = make('button','lmb-wishlist-share-channel',text('copy'));
    copy.prepend(icon('copy'));
    copy.type='button';
    copy.addEventListener('click',async () => {
      try {await navigator.clipboard.writeText(url); status.textContent=text('copied');}
      catch (_) {
        const input=make('input'); input.value=url; input.readOnly=true; input.setAttribute('aria-label',text('copy')); input.style.width='100%'; panel.append(input); input.select(); status.textContent=text('copy_error');
      }
    });
    channels.append(copy);
    const message = text('intro') + '\n' + url;
    const destinations=[['WhatsApp','whatsapp','https://wa.me/?text='+encodeURIComponent(message)],['Facebook','facebook','https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url)],['Email','mail','mailto:?subject='+encodeURIComponent(text('subject'))+'&body='+encodeURIComponent(message)]];
    destinations.forEach(([label,kind,href]) => {
      const link=make('a','lmb-wishlist-share-channel',label === 'Email' && config.dataset.locale === 'de' ? 'E-Mail' : label);
      link.href=href; link.prepend(icon(kind));
      if (kind !== 'mail') {link.target='_blank';link.rel='noopener noreferrer';}
      channels.append(link);
    });
    const instagram=make('button','lmb-wishlist-share-channel','Instagram');
    instagram.type='button';instagram.prepend(icon('instagram'));
    const instagramHelp=make('div','lmb-wishlist-share-instagram');instagramHelp.hidden=true;
    const instagramGuide=make('p','',text('instagram_guide'));
    const instagramOpen=make('a','lmb-wishlist-share-channel',text('instagram_open'));
    instagramOpen.href='https://www.instagram.com/';instagramOpen.target='_blank';instagramOpen.rel='noopener noreferrer';
    instagramOpen.prepend(icon('instagram'));instagramHelp.append(instagramGuide,instagramOpen);
    let instagramFallback;
    instagram.addEventListener('click',async()=>{
      instagramHelp.hidden=false;
      try {await navigator.clipboard.writeText(url);status.textContent=text('copied');}
      catch (_) {
        if (!instagramFallback) {
          instagramFallback=make('input');instagramFallback.value=url;instagramFallback.readOnly=true;
          instagramFallback.setAttribute('aria-label',text('copy'));instagramFallback.style.width='100%';instagramHelp.prepend(instagramFallback);
        }
        instagramFallback.select();status.textContent=text('copy_error');
      }
    });
    channels.append(instagram);
    if (typeof navigator.share==='function') {
      const device=make('button','lmb-wishlist-share-channel',text('device')); device.type='button';device.prepend(icon('share'));
      device.addEventListener('click',async()=>{try{await navigator.share({title:text('subject'),text:text('intro'),url});}catch(error){if(error.name!=='AbortError')status.textContent=text('copy_error');}});
      channels.append(device);
    }
    panel.append(channels,instagramHelp,status);
  }
  let scheduled=false;
  function attach() {
    scheduled=false;
    document.querySelectorAll('.nm-wishlist-drawer').forEach(drawer=>{
      const header=drawer.querySelector('.nm-wishlist-drawer-header');
      const body=drawer.querySelector('.nm-wishlist-drawer-body') || (header && header.nextElementSibling);
      if (!body) return;
      drawer.classList.add('lmb-wishlist-share-enabled');
      let action=drawer.querySelector('.lmb-wishlist-share-action');
      if (!action) {
        action=make('div','lmb-wishlist-share-action');
        const button=make('button','',text('share'));button.type='button';button.prepend(icon('share'));
        button.addEventListener('click',()=>share(wishlistHandles(drawer)));
        const note=make('p','',text('empty'));
        action.append(button,note);body.prepend(action);
      }
      const handles=wishlistHandles(drawer);
      const button=action.querySelector('button'); const note=action.querySelector('p');
      const disabled=handles.length===0;
      if (button.disabled!==disabled)button.disabled=disabled;
      if (note.hidden!==!disabled)note.hidden=!disabled;
    });
  }
  const observer=new MutationObserver(records=>{
    if (records.every(record=>record.target instanceof Element && record.target.closest('.lmb-wishlist-share-action, .lmb-wishlist-share-dialog'))) return;
    if (!scheduled) {scheduled=true;requestAnimationFrame(attach);}
  });
  observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
  attach();
  async function receive() {
    if (!location.hash.startsWith('#lmb-wishlist='))return;
    const panel=dialog(text('shared_title'));
    panel.append(make('p','',text('note')));
    let handles;
    try {
      if(location.hash.length>6000)throw new Error('size');
      const value=decodeURIComponent(location.hash.slice('#lmb-wishlist='.length));
      if(!value.startsWith('1:'))throw new Error('version');
      handles=value.slice(2).split(',');
      if(!handles.length||handles.length>max||handles.some(handle=>!handlePattern.test(handle))||new Set(handles).size!==handles.length)throw new Error('payload');
    }catch(_){panel.append(make('p','',text('invalid')));return;}
    const status=make('p','lmb-wishlist-share-status',text('loading'));status.setAttribute('role','status');panel.append(status);
    const list=make('div');panel.append(list);
    const rows=handles.map(handle=>{const row=make('article','lmb-wishlist-share-product');list.append(row);return{handle,row};});
    let next=0;
    async function worker() {
      while(next<rows.length) {
        const {handle,row}=rows[next++];
        const controller=new AbortController(); const timer=setTimeout(()=>controller.abort(),10000);
        try {
          const response=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',signal:controller.signal});
          if(!response.ok)throw new Error('missing');
          const product=await response.json();
          if(!product||typeof product.title!=='string')throw new Error('invalid');
          const title=decodeProductTitle(product.title);
          const details=make('div');details.append(make('h3','',title));
          if(typeof product.price==='number'&&Number.isFinite(product.price)) {
            try{details.append(make('p','',new Intl.NumberFormat(config.dataset.locale||'en',{style:'currency',currency:config.dataset.currency||'EUR'}).format(product.price/100)));}catch(_){}
          }
          if(product.available===false)details.append(make('p','',text('out_of_stock')));
          const link=make('a','',text('view_product'));link.href=root+'products/'+handle;details.append(link);
          const image=typeof product.featured_image==='string'?product.featured_image:null;
          if(image){const imageUrl=new URL(image,location.origin);if(imageUrl.protocol==='https:'&&(imageUrl.origin===location.origin||imageUrl.hostname==='cdn.shopify.com'||imageUrl.hostname.endsWith('.myshopify.com'))){const img=make('img');img.src=imageUrl.href;img.alt=title;img.loading='lazy';img.width=86;img.height=108;row.append(img);}}
          if (!row.querySelector('img')) row.classList.add('lmb-wishlist-share-product-no-image');
          row.append(details);
        }catch(_){row.append(make('p','',text('unavailable')));}
        finally{clearTimeout(timer);}
      }
    }
    await Promise.all(Array.from({length:Math.min(4,rows.length)},worker));
    status.textContent='';
  }
  receive();
})();

